<template>
  <svg
    viewBox="0 0 367 291"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="hidden"
  >
    <defs>
      <clipPath id="incomingClip0">
        <rect x="994" y="2684" width="367" height="291" />
      </clipPath>
      <clipPath id="incomingClip1">
        <rect x="1086" y="2684" width="274" height="274" />
      </clipPath>
      <clipPath id="incomingClip2">
        <rect x="1086" y="2684" width="274" height="274" />
      </clipPath>
      <clipPath id="incomingClip3">
        <rect x="1086" y="2684" width="274" height="274" />
      </clipPath>
    </defs>
    <g clip-path="url(#incomingClip0)" transform="translate(-994 -2684)">
      <g clip-path="url(#incomingClip1)">
        <g clip-path="url(#incomingClip2)">
          <g clip-path="url(#incomingClip3)">
            <path
              d="M1178.68 2913.64C1165.61 2927.31 1143.93 2927.8 1130.25 2914.73 1116.57 2901.66 1116.08 2879.97 1129.15 2866.3 1129.51 2865.92 1129.87 2865.56 1130.25 2865.2L1181.65 2813.91C1195.03 2800.54 1216.71 2800.54 1230.09 2813.91 1236.63 2820.75 1247.47 2820.99 1254.31 2814.45 1261.14 2807.91 1261.38 2797.07 1254.84 2790.23 1254.67 2790.04 1254.48 2789.86 1254.3 2789.68 1227.55 2762.93 1184.18 2762.93 1157.43 2789.68 1157.43 2789.68 1157.43 2789.68 1157.43 2789.68L1106.06 2841.05C1079.3 2867.8 1079.3 2911.17 1106.05 2937.93 1132.8 2964.68 1176.17 2964.69 1202.93 2937.94L1228.62 2912.25C1235.55 2905.8 1235.94 2894.97 1229.5 2888.04 1223.06 2881.11 1212.22 2880.72 1205.29 2887.16 1204.99 2887.44 1204.7 2887.74 1204.42 2888.04L1178.68 2913.64ZM1264.35 2828.09C1250.97 2841.46 1229.29 2841.46 1215.91 2828.09 1209.38 2821.25 1198.54 2821 1191.69 2827.53 1184.85 2834.06 1184.6 2844.91 1191.14 2851.75 1191.31 2851.93 1191.5 2852.12 1191.68 2852.3 1218.43 2879.05 1261.8 2879.05 1288.55 2852.3 1288.55 2852.3 1288.55 2852.3 1288.55 2852.3L1339.92 2800.93C1366.67 2774.18 1366.67 2730.81 1339.92 2704.06 1313.17 2677.31 1269.8 2677.31 1243.05 2704.06L1217.38 2729.75C1210.45 2736.2 1210.06 2747.03 1216.5 2753.96 1222.94 2760.89 1233.78 2761.28 1240.71 2754.84 1241.01 2754.56 1241.3 2754.26 1241.58 2753.96L1267.28 2728.29C1279.92 2714.21 1301.58 2713.05 1315.66 2725.7 1329.73 2738.34 1330.89 2760 1318.24 2774.08 1317.42 2774.99 1316.55 2775.86 1315.64 2776.68L1264.35 2828.09Z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </g>
      <path
        d="M1177.82 2877.57C1177.82 2926.45 1138.42 2966.07 1089.82 2966.07 1041.21 2966.07 1001.82 2926.45 1001.82 2877.57 1001.82 2828.69 1041.21 2789.07 1089.82 2789.07 1138.42 2789.07 1177.82 2828.69 1177.82 2877.57Z"
        stroke="#FFFFFF"
        stroke-width="16"
        stroke-linecap="round"
        stroke-miterlimit="8"
        fill="currentColor"
        fill-rule="evenodd"
      />
      <path
        d="M1056 2878 1081.84 2906.12"
        stroke="#FFFFFF"
        stroke-width="18.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        fill="#DAE0E6"
        fill-rule="evenodd"
      />
      <path
        d="M0 0 25.7874 28.0438"
        stroke="#FFFFFF"
        stroke-width="18.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        fill="#DAE0E6"
        fill-rule="evenodd"
        transform="matrix(1 0 0 -1 1056 2877.04)"
      />
      <path
        d="M1066 2877 1123.97 2877"
        stroke="#FFFFFF"
        stroke-width="18.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        fill="#DAE0E6"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>
